import { createElement } from 'react';
import { ComponentType } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isEntryThroughTryout, isUserAuthenticated } from './GlobalFunctions';

type AuthenticatedProps = {
  component: ComponentType<any>;
  path?: string;
  exact?: boolean;
  strict?: boolean;
  sensitive?: boolean;
};

const Authenticated = ({
  component,
  ...rest
}: AuthenticatedProps) => (
  <Route
    {...rest}
    render={(props) => {
      return isUserAuthenticated() || isEntryThroughTryout() ? (
        createElement(component, { ...rest, ...props })
      ) : (
        <Redirect to='/login' />
      );
    }}
  />
);

export default Authenticated;
